import labelsEn from '../labels/en.json';

// Return false if broswer does not support locales, per `toLocateDateString` spec
function getLocaleSupport() {
    try {
        new Date().toLocaleDateString('i');
    } catch (e) {
        return e.name === 'RangeError';
    }
    return false;
}

// If localeDateString is supported with locale and options, generate array of labels using toLocaleDateString
function getLocaleDateStrings(locale, options, useMonth) {
    // If locale wasn't specified, use a valid BCP-47 formatted
    // but non-existing locale (xx-XX) to get the default values.
    const date = new Date(2017, 0, 1); // New Years was a Sunday.
    const supportsLocales = getLocaleSupport();
    const targetNum = useMonth ? 12 : 7;
    let labelArray = [];
    locale = !locale ? 'xx-XX' : locale;

    if (supportsLocales) {
        for (let i = 0; i < targetNum; i++) {
            labelArray.push(date.toLocaleDateString(locale, options));
            if (useMonth) {
                date.setMonth(date.getMonth() + 1);
            } else {
                date.setDate(date.getDate() + 1);
            }
        }
        return labelArray;
    }
    return null;
}

// Return the default labels in English as a fallback
function getDefaultLabels(key) {
    return labelsEn[key];
}

function capitalizeFirstLetter([firstChar, ...rest], locale) {
    return [firstChar.toLocaleUpperCase(locale), ...rest].join('');
}

function applyLocaleSpecificCapitalization(str, locale) {
    // In some locales, month is not capitalized unless it is the first word in a phrase.
    // Since javascript api doesn't handle this context, we are adding a check for it here.
    const affectedLocales = ['da-DK'];
    const isAffectedLocale = affectedLocales.indexOf(locale) > -1;

    return isAffectedLocale ? capitalizeFirstLetter(str, locale) : str;
}

export {
    getDefaultLabels,
    getLocaleDateStrings,
    capitalizeFirstLetter,
    applyLocaleSpecificCapitalization
};
